import { render, staticRenderFns } from "./MinisiteFooter.vue?vue&type=template&id=4bf7f0a2"
import script from "./MinisiteFooter.vue?vue&type=script&lang=js"
export * from "./MinisiteFooter.vue?vue&type=script&lang=js"
import style0 from "./MinisiteFooter.vue?vue&type=style&index=0&id=4bf7f0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports